<template>
  <v-row>
    <v-col>
      <v-card outlined :max-height="400" :min-height="200">
        <v-card-title class="py-1">{{ $t("Available") }}</v-card-title>
        <v-toolbar dense flat>
          <v-text-field
            v-model="searchSource"
            hide-details
            prepend-icon="mdi-magnify"
            single-line
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-list dense style="max-height: 300px" class="overflow-y-auto">
            <v-list-item-group>
              <draggable :list="source" draggable=".draggableItem">
                <v-list-item
                  :key="item.title"
                  v-for="(item, index) in source"
                  @click="moveToDestination(getItemId(item))"
                  class="draggableItem"
                  :style="{ backgroundColor: index % 2 == 0 ? '#f1f1f1' : '' }"
                  v-show="isItemVisible(item, searchSource)"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-list-item-content v-on="on">
                        <v-list-item-title
                          class="text-truncate"
                          style="max-width: 200px"
                          v-text="getItemText(item)"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <span>{{ getItemText(item) }}</span>
                  </v-tooltip>
                  <v-list-item-icon v-if="getItemCondition(item)">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="warning" class="mr-2">{{
                          iconCondition
                        }}</v-icon>
                      </template>
                      <span>{{ $t(getMessageCondition()) }}</span>
                    </v-tooltip>
                  </v-list-item-icon>
                </v-list-item>
              </draggable>
            </v-list-item-group>
          </v-list>
          <base-no-data
            v-if="source.length == 0"
            icon="mdi-format-list-checkbox"
            text=" "
          />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="1">
      <v-row align="center" justify="center" class="pt-10 mt-10">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small color="primary" v-on="on" @click="moveAllDestination">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("SelectAll") }}</span>
        </v-tooltip>
      </v-row>
      <v-row align="center" justify="center" class="pt-5">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small color="primary" v-on="on" @click="moveAllSource">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("UnselectAll") }}</span>
        </v-tooltip>
      </v-row>
    </v-col>
    <v-col>
      <v-card outlined :max-height="400" :min-height="200">
        <v-card-title class="py-1">{{ $t("Selected") }}</v-card-title>
        <v-toolbar dense flat>
          <v-text-field
            v-model="searchDestination"
            hide-details
            prepend-icon="mdi-magnify"
            single-line
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-list dense style="max-height: 300px" class="overflow-y-auto">
            <v-list-item-group>
              <draggable :list="destination" draggable=".draggableItem">
                <v-list-item
                  v-for="(item, index) in destination"
                  :key="item.title"
                  class="draggableItem"
                  :style="{ backgroundColor: index % 2 == 0 ? '#f1f1f1' : '' }"
                  v-show="isItemVisible(item, searchDestination)"
                  @click="moveToSource(getItemId(item))"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-list-item-content v-on="on">
                        <v-list-item-title
                          class="text-truncate"
                          style="max-width: 200px"
                          v-text="getItemText(item)"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <span>{{ getItemText(item) }}</span>
                  </v-tooltip>
                  <v-list-item-icon v-if="getItemCondition(item)">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="warning" class="mr-2">{{
                          iconCondition
                        }}</v-icon>
                      </template>
                      <span>{{ $t(getMessageCondition()) }}</span>
                    </v-tooltip>
                  </v-list-item-icon>
                </v-list-item>
              </draggable>
            </v-list-item-group>
          </v-list>
          <base-no-data
            v-if="destination.length == 0"
            icon="mdi-format-list-checkbox"
            text=" "
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: {
    source: Array,
    destination: Array,
    itemText: String,
    itemId: String,
    itemCondition: String,
    iconCondition: String,
    messageCondition: String
  },
  data() {
    return {
      searchSource: "",
      searchDestination: "",
    };
  },
  computed: {
    filterdSource() {
      return this.source.filter((i) =>
        this.isItemVisible(i, this.searchSource)
      );
    },
    filteredDestination() {
      return this.destination.filter((i) =>
        this.isItemVisible(i, this.searchDestination)
      );
    },
  },
  methods: {
    getMessageCondition(){
      return this.messageCondition;
    },
    getItemText(item) {
      return item[this.itemText in item ? this.itemText : "text"] || "";
    },
    getItemId(item) {
      return item[this.itemId in item ? this.itemId : "id"] || "";
    },
    getItemCondition(item) {
      return item[this.itemCondition in item ? this.itemCondition : false];
    },
    isItemVisible(item, search) {
      return this.getItemText(item)
        .toLowerCase()
        .includes((search || "").toLowerCase());
    },
    moveToDestination(key) {
      let selected = this.filterdSource.filter((f) => this.getItemId(f) == key);

      if (!selected.length) return;
      let destination = [...selected, ...this.destination];
      let source = this.source.filter((f) => this.getItemId(f) != key);
      this.$emit("onChangeList", {
        source,
        destination,
      });
    },
    moveToSource(key) {
      let selected = this.filteredDestination.filter(
        (f) => this.getItemId(f) == key
      );

      if (!selected.length) return;

      let source = [...selected, ...this.source];
      let destination = this.destination.filter(
        (f) => this.getItemId(f) != key
      );
      this.$emit("onChangeList", {
        source,
        destination,
      });
    },
    moveAllDestination() {
      let filtered = this.filterdSource;

      let noFiltered = this.source.filter(
        (i) => !this.isItemVisible(i, this.searchSource)
      );

      let destination = [...filtered, ...this.destination];
      let source = noFiltered;

      this.$emit("onChangeList", {
        source,
        destination,
      });
    },
    moveAllSource() {
      let filtered = this.filteredDestination;

      let noFiltered = this.destination.filter(
        (i) => !this.isItemVisible(i, this.searchDestination)
      );

      let source = [...filtered, ...this.source];
      let destination = noFiltered;
      this.$emit("onChangeList", {
        source,
        destination,
      });
    },
  },
};
</script>
